import { authEpic } from './auth';
import { combineEpics } from 'redux-observable';
import { eventEpic } from './event';
import { pageEpics } from './page';
import { placeEpic } from './place';
import { redirectEpic } from './redirect-epic';
import { uploadImageEpic } from './upload-image-epic';

export const adminRootEpic = combineEpics(
  pageEpics,
  authEpic,
  eventEpic,
  placeEpic,
  redirectEpic,
  uploadImageEpic,
);
